import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaPlus,
  FaUser,
  FaCompass,
  FaStore,
} from "react-icons/fa";
import { useMobileNav } from "../../contexts/MobileNavContext";
import { useUserAuth } from "../../contexts/UserAuthContext";
import { usePublicPages } from "../../contexts/PublicPagesContext";
import { getOwnProfilePath } from "../../utils/profilePaths";
import styles from "../../styles/components/layout/MobileBottomNav.module.css";

const MobileBottomNav = () => {
  const location = useLocation();
  const { openCreatePost } = useMobileNav();
  const { user } = useUserAuth();
  const { isPageEnabled } = usePublicPages();
  const pathname = location.pathname;
  const userId = user?.id || user?._id;
  const profilePath = user ? getOwnProfilePath(user) : "/login?mode=login";
  const marketplaceEnabled = isPageEnabled("marketplace");
  const feedEnabled = isPageEnabled("feed");
  const navColumnCount =
    2 + (feedEnabled ? 2 : 0) + (marketplaceEnabled ? 1 : 0);

  // Home points to the real home page (CategoriesPage at "/")
  const homeTarget = "/";

  // Explicit, mutually exclusive active checks
  const isHomeActive =
    pathname === "/" ||
    pathname === "/category" ||
    pathname.startsWith("/category/") ||
    pathname === "/search" ||
    pathname.startsWith("/search/");

  // Browse can point to the community feed (a separate content feed page)
  const browseTarget = "/community";

  const isBrowseActive =
    pathname === "/community" || pathname.startsWith("/community/");

  const isMarketplaceActive =
    pathname === "/marketplace" || pathname.startsWith("/marketplace/");

  const isProfileActive =
    userId &&
    (pathname === `/user/${userId}` || pathname.startsWith(`/user/${userId}/`));

  return (
    <nav
      className={`${styles.mobileBottomNav} ${styles[`cols${navColumnCount}`] || ""}`}
      aria-label="Mobile navigation"
    >
      <Link
        to={homeTarget}
        aria-label="Home"
        className={`${styles.mobileBottomNavItem} ${
          isHomeActive ? styles.mobileBottomNavItemActive : ""
        }`}
      >
        <FaHome />
        <span>Home</span>
      </Link>
      {feedEnabled ? (
        <Link
          to={browseTarget}
          aria-label="Community"
          className={`${styles.mobileBottomNavItem} ${
            isBrowseActive ? styles.mobileBottomNavItemActive : ""
          }`}
        >
          <FaCompass />
          <span>Community</span>
        </Link>
      ) : null}
      {feedEnabled ? (
        <button
          type="button"
          className={`${styles.mobileBottomNavItem} ${styles.mobileBottomNavCreate}`}
          onClick={openCreatePost}
          aria-label="Create a post"
        >
          <FaPlus />
          <span>Create</span>
        </button>
      ) : null}
      {marketplaceEnabled ? (
        <Link
          to="/marketplace"
          aria-label="Marketplace"
          className={`${styles.mobileBottomNavItem} ${
            isMarketplaceActive ? styles.mobileBottomNavItemActive : ""
          }`}
        >
          <FaStore />
          <span>Market</span>
        </Link>
      ) : null}
      <Link
        to={profilePath}
        aria-label="Profile"
        className={`${styles.mobileBottomNavItem} ${
          isProfileActive ? styles.mobileBottomNavItemActive : ""
        }`}
      >
        <FaUser />
        <span>Profile</span>
      </Link>
    </nav>
  );
};

export default MobileBottomNav;
